import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-text">Hüseyin Zeray</span>
          <span className="logo-subtitle">Yağlı Boya Sanatçısı</span>
        </Link>
        
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
          <li>
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'active' : ''}
              onClick={() => setMenuOpen(false)}
            >
              Ana Sayfa
            </Link>
          </li>
          <li>
            <Link 
              to="/arsiv" 
              className={location.pathname === '/arsiv' ? 'active' : ''}
              onClick={() => setMenuOpen(false)}
            >
              Arşiv
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
